package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.navigation.logout
import com.klantenstop.web.styles.Typography
import com.materialkobweb.styles.MaterialColorVars
import com.materialkobweb.components.sections.NavigationItem
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.px

@Composable
fun AdminNavigationItems(
    onItemClick: (() -> Unit)? = null
) {
    val context = rememberPageContext()
    val currentPath = context.route.path

    H2Heading(
        modifier = Modifier.margin(bottom = 30.px),
        typography = Typography.TitleLarge,
        text = "Dashboard",
        color = MaterialColorVars.OnSecondaryContainer.value()
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 16.px),
        selected = currentPath == Navigation.Screen.Admin.Home.route,
        title = "Home",
        icon = "home",
        href = Navigation.Screen.Admin.Home.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 16.px),
        selected = currentPath.contains(Navigation.Screen.Admin.Categories.Index.route),
        title = "Categories",
        icon = "interests",
        href = Navigation.Screen.Admin.Categories.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 16.px),
        selected = currentPath.contains(Navigation.Screen.Admin.CuratedCities.Index.route),
        title = "Cities",
        icon = "location_city",
        href = Navigation.Screen.Admin.CuratedCities.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 16.px),
        selected = currentPath.contains(Navigation.Screen.Admin.Companies.Index.route),
        title = "Companies",
        icon = "store",
        href = Navigation.Screen.Admin.Companies.Index.route
    )

    NavigationItem(
        modifier = Modifier.margin(bottom = 16.px),
        title = "Settings",
        selected = currentPath.contains(Navigation.Screen.Admin.Settings.route),
        icon = "settings",
        href = Navigation.Screen.Admin.Settings.route
    )

    NavigationItem(
        modifier = Modifier.margin(top = 75.px),
        title = "Logout",
        icon = "logout",
        href = Navigation.Screen.Home.route,
        onClick = {
            logout()
            onItemClick?.invoke()
        }
    )
}
